import { useEffect, useRef } from 'react';
import s from '#components/feedback/progress-bar/progressBar.module.scss';

type Props = {
  total: number;
  value: number;
  classes?: string;
  rounded?: boolean;
  color?: 'secondary' | 'primary';
};

const ProgressBar = ({
  value,
  total,
  rounded = true,
  classes,
  color = 'primary',
}: Props) => {
  const progressPercentage = (value / total) * 100;
  const myRef = useRef<HTMLDivElement | undefined>();

  useEffect(() => {
    if (myRef.current) {
      myRef.current.style.setProperty(
        '--progress-bar-filled',
        `${progressPercentage}%`
      );
    }
  });

  return (
    <div
      ref={myRef}
      className={`${s.host} ${classes || ''} ${rounded && s.rounded} ${
        color === 'secondary' && s.secondary
      }`}
    />
  );
};

export default ProgressBar;
